import { 
  Box,
  Typography, 
  Card, 
  Button, 
} from "@mui/material";
import { CiMail, CiPhone, CiLocationOn } from "react-icons/ci";
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';


// Componente estilizado
const ContactCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(6, 4),
  background: 'linear-gradient(135deg, #0A0515 0%, #05020B 100%)',
  borderRadius: 24,
  maxWidth: 1000,
  margin: '0 auto',
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(8),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3), 0 10px 20px rgba(58, 195, 227, 0.1)',
  overflow: 'hidden',
  position: 'relative',
  border: '1px solid rgba(58, 195, 227, 0.05)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 6,
    background: 'linear-gradient(90deg, #3AC3E3, #2B8AC6, #3AC3E3)',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    padding: theme.spacing(8, 6),
  },
}));

const ContactInfoItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  padding: theme.spacing(3),
  borderRadius: 16,
  backgroundColor: 'rgba(10, 5, 21, 0.8)',
  boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
  transition: 'all 0.3s ease',
  marginBottom: theme.spacing(3),
  opacity: 0,
  transform: 'translateY(20px)',
  animation: 'fadeInUp 0.6s ease forwards',
  border: '1px solid rgba(255, 255, 255, 0.05)',
  '&:nth-of-type(1)': { animationDelay: '0.1s' },
  '&:nth-of-type(2)': { animationDelay: '0.2s' },
  '&:nth-of-type(3)': { animationDelay: '0.3s' },
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 12px 25px rgba(0, 0, 0, 0.3)',
    backgroundColor: 'rgba(58, 195, 227, 0.05)',
    border: '1px solid rgba(58, 195, 227, 0.2)',
    '& .contact-icon': {
      backgroundColor: 'rgba(58, 195, 227, 0.2)',
      color: '#3AC3E3',
    },
  },
  '@keyframes fadeInUp': {
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    }
  }
}));

const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 56,
  height: 56,
  borderRadius: 14,
  backgroundColor: 'rgba(58, 195, 227, 0.1)',
  color: '#3AC3E3',
  marginRight: theme.spacing(2),
  transition: 'all 0.3s ease',
  flexShrink: 0,
}));

const AnimatedBox = styled(Box)({
  opacity: 0,
  transform: 'translateY(20px)',
  animation: 'fadeInUp 0.6s ease forwards',
  animationDelay: '0s',
});

function ContactUs() {

  return (
    <ContactCard>
      <Box sx={{ 
        flex: 1, 
        textAlign: { xs: 'center', md: 'left' },
        mb: { xs: 5, md: 0 },
        pr: { md: 4 }
      }}>
        <AnimatedBox>
          <Typography
            variant="overline"
            sx={{
              fontWeight: 600,
              mb: 2,
              color: '#3AC3E3',
              letterSpacing: 3,
              fontSize: '0.8rem',
              display: 'block',
            }}
          >
            {/* Título Overline Atualizado */}
            ENTERPRISE PARTNERSHIP
          </Typography>
          <Typography variant="h3" sx={{ 
            fontWeight: 700, 
            mb: 2,
            fontSize: { xs: 32, md: 40 },
            color: 'white'
          }}>
            {/* Título Principal Atualizado */}
            Discuss Your Next Project
          </Typography>
          <Typography variant="body1" sx={{ 
            mb: 4, 
            color: 'rgba(255, 255, 255, 0.8)',
            lineHeight: 1.6,
            fontSize: '1.1rem'
          }}>
            {/* Descrição Atualizada para B2B */}
            We are dedicated exclusively to providing fiber construction and solutions for businesses and service providers. Let's build your high-speed infrastructure.
          </Typography>
          <RouterLink to="/contact-us" style={{ textDecoration: 'none' }}>
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              sx={{
                borderRadius: 12,
                px: 4,
                py: 1.5,
                fontWeight: 600,
                fontSize: '1rem',
                backgroundColor: '#3AC3E3',
                boxShadow: '0 8px 20px rgba(58, 195, 227, 0.4)',
                '&:hover': {
                  backgroundColor: '#2B8AC6',
                  boxShadow: '0 12px 25px rgba(58, 195, 227, 0.5)',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              {/* Botão Atualizado */}
              Request a Project Quote
            </Button> 
          </RouterLink>
        </AnimatedBox>
      </Box>

      <Box sx={{ 
        flex: 1.2,
        width: '100%'
      }}>
        <ContactInfoItem>
          <IconContainer className="contact-icon">
            <CiMail size={24} />
          </IconContainer>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, color: 'white' }}>
              {/* Título Atualizado */}
              Project Inquiries
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              {/* Email Sugerido para B2B */}
              projects@brothersfiber.com
            </Typography>
          </Box>
        </ContactInfoItem>

        <ContactInfoItem>
          <IconContainer className="contact-icon">
            <CiPhone size={24} />
          </IconContainer>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, color: 'white' }}>
              {/* Título Atualizado */}
              Commercial Line
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              +1 515 850 9012
            </Typography>
          </Box>
        </ContactInfoItem>

        <ContactInfoItem>
          <IconContainer className="contact-icon">
            <CiLocationOn size={24} />
          </IconContainer>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, color: 'white' }}>
              Company Location
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              243 Boston Post RD E APT 2, Marlborough - MA 01752
            </Typography>
          </Box>
        </ContactInfoItem>
      </Box>
    </ContactCard>
  );
}

export default ContactUs;